<template>
  <svg
    class="ws-cary-spinner"
    :width="width"
    :height="height"
    viewBox="0 0 64 26"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <linearGradient
        id="gradient_dark"
        x1="100%"
        y1="0%"
        x2="0%"
        y2="0%"
      >
        <stop offset="0" style="stop-color:rgba(44, 56, 67, 0);" />
        <stop offset="50%" style="stop-color:rgba(44, 56, 67, 1)" />
        <stop offset="100%" style="stop-color:rgba(44, 56, 67, 0)" />
      </linearGradient>
      <linearGradient
        id="gradient_white"
        x1="100%"
        y1="0%"
        x2="0%"
        y2="0%"
      >
        <stop offset="0" style="stop-color:rgba(255,255,255,0);" />
        <stop offset="50%" style="stop-color:rgba(255,255,255,1)" />
        <stop offset="100%" style="stop-color:rgba(255,255,255,0)" />
      </linearGradient>
      <linearGradient
        id="gradient_default"
        x1="100%"
        y1="0%"
        x2="0%"
        y2="0%"
      >
        <stop offset="0" style="stop-color:rgba(0,250,160,0);" />
        <stop offset="50%" style="stop-color:#00FFA0;" />
        <stop offset="100%" style="stop-color:rgba(0,250,160,0)" />
      </linearGradient>
    </defs>
    <pattern
      :id="`pattern_${color || 'default'}`"
      x="0"
      y="0"
      width="400%"
      height="100%"
      patternUnits="userSpaceOnUse"
    >
      <rect
        x="-100%"
        y="0"
        width="200%"
        height="100%"
        :fill="`url(#gradient_${color || 'default'})`"
        transform="rotate(0)"
      >
        <animate
          attributeType="XML"
          attributeName="x"
          from="-400%"
          to="100%"
          dur="1.25s"
          repeatCount="indefinite"
        />
      </rect>
    </pattern>
    <g
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <path
        :fill="`url(#pattern_${color || 'default'})`"
        fill-rule="nonzero"
        d="M10.6641 20.0838L17.9686 3.22916C18.5365 1.86109 19.8652
           0.982178 21.3326 0.982178C22.8043 0.982178 24.0821 1.86109
           24.6998 3.22916L31.9989 20.0838L39.3013 3.22916C39.8713 1.86109
           41.1978 0.982178 42.6663 0.982178C44.137 0.982178 45.4158
           1.86109 46.0335 3.22916L53.3315 20.0838L60.636 3.22916C61.2039
           1.86109 62.5315 0.982178 64 0.982178V6.50359L56.8429
           22.7227C56.1764 24.188 54.8499 25.0177 53.3315 25.0177C51.8154
           25.0177 50.4867 24.188 49.8267 22.7227L42.6663 6.50359L35.5092
           22.7227C34.8427 24.188 33.5151 25.0177 31.9989 25.0177C30.4817
           25.0177 29.1541 24.188 28.493 22.7227L21.3326 6.50359L14.1755
           22.7227C13.509 24.188 12.1825 25.0177 10.6641 25.0177C9.14796
           25.0177 7.82037 24.188 7.1582 22.7227L0 6.50359V0.982178C1.46957
           0.982178 2.74949 1.86109 3.36614 3.22916L10.6641 20.0838Z"
      />
    </g>
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'WsCarySpinner',
  props: {
    color: {
      type: String,
      default: 'dark',
    },
    width: {
      type: String,
      default: '80px',
    },
    height: {
      type: String,
      required: false,
      default: '30px',
    }
  },
});
</script>
